/*
 * @Author: zhangliang
 * @Date: 2020-01-30 19:35:33
 * @LastEditTime: 2020-02-24 10:19:10
 * @LastEditors: zhangliang
 * @Description: 
 * @FilePath: \asset_app\src\utils\common.js
 */
// 判断是app内，还是app以外打开H5
function isInAppBrowser() {
  let platform = window.navigator.platform
  let ua = window.navigator.userAgent.toLowerCase();
  if (platform.includes('Win')) { // pc端浏览器模拟器打开
    return false
  } else {
    // if (ua.match(/MicroMessenger/i) == "micromessenger") { // 真机微信内打开
    //   return false
    // } else if (ua.includes('mqqbrowser')) { // 真机qq浏览器内打开
    //   return false
    // } else if (ua.includes('miuibrowser')) { // 真机小米浏览器内打开
    //   return false
    // } else if (ua.includes('ucbrowser')) { // 真机uc浏览器内打开
    //   return false
    // } else if (ua.includes('safari')) { // 真机safari浏览器内打开
    //   return false
    // } else {
      return true
    // }
  }
}

// 调用原生公共方法
function messagePost(name, obj) {
  //判断安卓 or ios
  var u = navigator.userAgent
  var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1 //android终端
  var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) //ios终端
  let str = JSON.stringify(obj)
  if (isAndroid) {
    //这个是安卓操作系统
    try {
      // eslint-disable-next-line no-undef
      android[name](str)
    } catch (e) {
      window.console.log(e)
    }
  } else if (isIOS) {
    //这个是ios操作系统
    try {
      window.webkit.messageHandlers[name].postMessage(str)
    } catch (e) {
      window.console.log(e)
    }
  }
}

export {
  isInAppBrowser,
  messagePost
}